import { apiService } from '@/services/APIService';

export default {

  get(id, params) {
    return apiService.get(`/email-settings/${id}`, params);
  },

  create(params) {
    return apiService.post('/email-settings', params);
  },

  delete(id) {
    return apiService.delete(`/email-settings/${id}`);
  },
  checkConnectEmail(id) {
    return apiService.post(`/email-settings/${id}/check-connect`);
  },
};
